import FormText from './FormText';

export default FormText;
